<template>
  <div id="main" class="reportContainer">
    <div class="coverContainer">
      <img :src="topImg" alt="">
      <div class="coverInfo">
        {{ pageInfo.studentId }}/{{ pageInfo.studentName }}/{{
          pageInfo.studentGrade + pageInfo.studentClass
        }}/{{ pageInfo.school }}
      </div>
    </div>
    <div class="bigTitle introT" />
    <SamllTitle title="测评简介" />
    <div class="intro">
      <div class="introItem">
        儿少心理健康量表(mental health scale forchild and
        adolescent，MHS-CA)由程灶火等于2001年编制，于2004年完成信效度研究和全国常模建立。该量表从24个方面去观察儿童和青少年的心理健康状况，既能反映儿童和青少年的心理过程，也反映儿童和青少年的心理特征。该量表的信效度较好，符合统计学标准。
      </div>
      <div class="introItem">
        儿少心理健康量表属于评定量表，小学低年级（一年级～三年级）由父母与孩子共同讨论填写，小学高年级（四年级～六年级）、中学生可以自己填写。评定时限为“目前”或“最近一个月”的实际情况。
      </div>
    </div>
    <SamllTitle title="量表内容" />
    <div class="intro">
      <div class="introItem" style="margin-top: 70px">
        量表包括24个反映儿童心理过程和特征的条目，这些条目可细分为5个维度（分量表）。
      </div>
    </div>
    <div class="detailContainner">
      <div v-for="(item, index) in detailList" :key="index" class="detailItem">
        <div class="itemTitle">
          <img :src="item.title" alt="">
        </div>
        <div class="itemValue">
          {{ item.content }}
        </div>
      </div>
    </div>
    <SamllTitle title="参考文献" style="margin-top: 55px" />
    <div class="literatureContainer">
      <div
        v-for="(item, index) in literature"
        :key="index"
        class="literatureItem"
      >
        <div class="literatureTitle">
          <div class="icon" />
        </div>
        <div class="literatureValue">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="bigTitle resultT" />
    <SamllTitle title="测评结果" />
    <div class="resultChart">
      <div id="myCharts" />
    </div>
    <div class="bigTitle ExplanT" />
    <div v-if="data" class="dimentionContainer">
      <div
        v-for="(dimention, index) in data.items"
        :key="index"
        class="dimention"
      >
        <SamllTitle :title="dimention.scaleName" />
        <div class="dimentionLi">
          <div class="dimentionTitle">
            <div class="icon" />
            <span>结果得分：</span>
          </div>
          <div class="content">
            <div class="indicatorBar">
              <!-- <div :class="classList[index] + ' ' + 'bar'"> -->
              <div class="bar">
                <!-- <div
                  v-for="(val, key, i) in dimention.attach"
                  :key="i"
                  :style="{
                    width: (val.max - val.min + 1) * 40 + 'px',
                  }"
                  > -->
                <div
                  v-for="(val, key, i) in dimention.attach"
                  :key="i"
                  :class="key + 'Css ' + 'progressDivCss'"
                  :style="{
                    width:
                      (val.max - val.min + 1) /
                      ((dimention.attach.high.max -
                        dimention.attach.early.min +
                        1) /
                        100) +
                      '%',
                    height: '2em',
                  }"
                >
                  <!-- <img
                    :src="imgUrlFilter(classList[index], key)"
                    :style="{width: (val.max - val.min + 1) * 40 + 'px',}"
                    alt=""
                  /> -->
                  <!-- <div
                    class="arrow"
                    v-if="
                      val.max >= dimention.score && val.min <= dimention.score
                    "
                    :style="{
                      left:
                        ((dimention.score - val.min) / (val.max - val.min)) *
                          (val.max - val.min + 1) *
                          40 -
                        16 +
                        'px',
                    }"
                  ></div> -->
                  <!-- <img
                    :src="imgUrlFilter('caseReport265', key)"
                    class="progressImg"
                    alt=""
                  /> -->
                  <a v-if="key == 'early'" class="progressText"> 预警 </a>
                  <a v-if="key == 'subhealthy'" class="progressText">
                    亚健康
                  </a>
                  <a v-if="key == 'commonly'" class="progressText">
                    一般健康
                  </a>
                  <a v-if="key == 'preferably'" class="progressText">
                    较好健康
                  </a>
                  <a v-if="key == 'high'" class="progressText"> 高健康 </a>
                  <!--左移三角标是以左侧为边距，若结果=0则不需要减去本身，左侧与进度条左侧平齐-->
                  <div
                    v-if="
                      val.max >= dimention.score &&
                        val.min <= dimention.score &&
                        (dimention.score - val.min) /
                        ((val.max - val.min) / 100) <=
                        8.5
                    "
                    class="arrow"
                    style="left: 0%"
                  />
                  <!--左移三角标是以左侧为边距，所以需要减去图标本身一半的宽度，让三角表中线对其落点位置-->
                  <div
                    v-if="
                      val.max >= dimention.score &&
                        val.min <= dimention.score &&
                        (dimention.score - val.min) /
                        ((val.max - val.min) / 100) >
                        8.5
                    "
                    class="arrow"
                    :style="{
                      left:
                        (dimention.score - val.min) /
                        ((val.max - val.min) / 100) -
                        8.5 +
                        '%',
                    }"
                  />
                </div>
              </div>
            </div>
            {{ dimention.scaleName }}得分：<span>{{ dimention.score }}分</span>{{ dimention.conclusion }}
          </div>
        </div>
        <div class="dimentionLi">
          <div class="dimentionTitle">
            <div class="icon" />
            <span>结果解释：</span>
          </div>
          <div class="content" v-html="dimention.explain" />
        </div>
        <div class="dimentionLi">
          <div class="dimentionTitle">
            <div class="icon" />
            <span>建议：</span>
          </div>
          <div class="content" v-html="dimention.advise" />
        </div>
      </div>
    </div>
    <div class="bigTitle noticeT" />
    <div class="intro">
      <div class="introItem">
        本测评结果不可作为精神疾病、心理障碍诊断的依据。如需专业诊断，请前往医院的精神科或心理科就诊。
      </div>
    </div>
  </div>
</template>
<script>
import SamllTitle from '../../components/smallTitle.vue'
import { mixins } from '../../utils/mixins'
import { getChildrenPersonReportData } from '../../api/report'
// import wsPdf from "../../utils/htmlToPdf"
import getReportPdf from '../../utils/getReportPdf'
// import request from "../../utils/request";
// import Html2Canvas from "html2canvas";
// import { jsPDF } from "jspdf";
export default {
  components: {
    SamllTitle
  },
  mixins: [mixins],
  data() {
    return {
      id: '',
      pageInfo: {},
      studentId: '',
      studentName: '',
      radarOptions: {},
      classList: [
        'cognition',
        'thinkingAndLanguage',
        'personality',
        'mood',
        'will'
      ],
      data: undefined,
      detailList: [
        {
          title: require('../../assets/images/caseReport/detail1.png'),
          content: '包括感知觉、注意、记忆、智力、学习与工作5个条目。'
        },
        {
          title: require('../../assets/images/caseReport/detail2.png'),
          content:
            '包括思维过程、思维内容、思维自主性、语言表达、语言理解5个条目。'
        },
        {
          title: require('../../assets/images/caseReport/detail3.png'),
          content: '包括焦虑体验、愉快体验、情绪反应3个条目。'
        },
        {
          title: require('../../assets/images/caseReport/detail4.png'),
          content: '包括行为、活动、兴趣、人际交往、健康关注5个条目。'
        },
        {
          title: require('../../assets/images/caseReport/detail5.png'),
          content:
            '包括自信与自尊、安全与信任、责任感、活泼性、仁慈心、需要满足6个条目。'
        }
      ],
      literature: [
        '程灶火,袁国桢,杨碧秀,林燕,方有荣,赵勇,张轩,杨英,苏艳华,欧阳旭伟.儿童青少年心理健康量表的编制和信效度检验[J].中国心理卫生杂志,2006(01):15-18.',
        '袁国桢,程灶火,杨碧秀.不同地区中小学生心理健康状况的调查[J].中国临床康复,2006(34):50-52.',
        '杨碧秀,程灶火.不同年级的中小学生心理问题研究[J].中国健康心理学杂志,2006(03):270-272.',
        '杨碧秀,程灶火.不同年级的中小学生心理问题研究[J].中国健康心理学杂志,2006(03):270-272.'
      ],
      topImg: require('../../assets/images/caseReport/caseReport_top.png')
    }
  },
  created() {
    this.pageInfo = this.queryParams
    this.id = this.queryParams.reportId
    document.title = `${this.queryParams.reportId}个人报告 ${
      this.$route.query.studentId +
      this.$route.query.studentName +
      new Date().toLocaleDateString()
    }`
  },
  mounted() {
    // window.addEventListener('beforeprint', this.onBeforePrint)
    // window.addEventListener('afterprint', this.onAfterPrint)
    this.$fullScreenLoading.show('报告即将呈现...')
    this.getChildrenCaseReportData()
  },
  methods: {
    onBeforePrint() {
      document.getElementsByTagName('body')[0].style.zoom = '0.97'
    },
    onAfterPrint() {
      document.getElementsByTagName('body')[0].style.zoom = '1'
    },
    imgUrlFilter(className, key) {
      return require(`../../assets/images/${className}/${key}.png`)
    },
    // 儿少个案数据请求
    getChildrenCaseReportData() {
      var that = this
      getChildrenPersonReportData(that.queryParams).then((res) => {
        // 成功
        if (res.code === 200) {
          this.data = res.data
          var indicatorList = []
          var indicatorValue = []
          res.data.items.map((item) => {
            indicatorList.push({
              name: item.scaleName,
              max: 30,
              mix: 3
            })
            indicatorValue.push(item.score)
          })
          var radarOptions = {
            radar: {
              // shape: 'circle',
              radius: 150,
              name: {
                // (圆外的标签)雷达图每个指示器名称的配置项。
                textStyle: {
                  fontSize: 24
                }
              },
              center: ['50%', '50%'],
              indicator: indicatorList
            },
            splitArea: {
              show: false,
              areaStyle: {
                color: 'yellow' // 图表背景的颜色
              }
            },
            axisLine: {
              lineStyle: {
                color: 'yellow'
              }
            },
            series: [
              {
                symbolSize: 15,
                type: 'radar',
                itemStyle: {
                  normal: {
                    areaStyle: { type: 'default' }
                  }
                },
                data: [
                  {
                    name: '维度得分',
                    value: indicatorValue,
                    // 设置区域边框和区域的颜色
                    itemStyle: {
                      normal: {
                        color: 'rgba(255,225,0,1)',
                        lineStyle: {
                          color: 'rgba(255,225,0,1)'
                        }
                      }
                    }
                  }
                ]
              }
            ],
            tooltip: {
              // 雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
              confine: true,
              enterable: true // 鼠标是否可以移动到tooltip区域内
            }
          }

          /** ******************************** wsadd *****************/
          // var html = document.querySelector("#main")
          // let contentWidth = html.clientWidth // 获得该容器的宽
          // let contentHeight = html.clientHeight // 获得该容器的高
          //  var pageHeight = (contentWidth / 592.28) * 841.89
          // document.documentElement.style.width = "794px";
          const htmlHeight = document.getElementById('main').offsetHeight
          const printHeight = 1090 // (contentWidth / 592.28) * 841.89;//1090;
          if (htmlHeight > printHeight) {
            // 子元素总数
            const countElement =
              document.getElementById('main').childElementCount
            for (var i = 1; i < countElement; i++) {
              const chilOffsetTop =
                document.getElementById('main').children[i].offsetTop
              const chilOffsetHeight =
                document.getElementById('main').children[i].offsetHeight
              if (
                chilOffsetTop < printHeight &&
                printHeight - chilOffsetTop < chilOffsetHeight
              ) {
                document.getElementById('main').children[i].style.paddingTop =
                  printHeight - chilOffsetTop + 50 + 50 + 'px'
              } else if (
                chilOffsetTop > printHeight &&
                printHeight - (chilOffsetTop % printHeight) < chilOffsetHeight
              ) {
                document.getElementById('main').children[i].style.paddingTop =
                  printHeight - (chilOffsetTop % printHeight) + 100 + 'px'
              }
            }
          }

          /** **************** ws end ****************/

          setTimeout(() => {
            var myCharts = this.$Echarts.init(
              document.getElementById('myCharts')
            )
            myCharts.setOption(radarOptions)
            this.$fullScreenLoading.hide()
            // if (this.$route.query.isExport == 1) {
            if (this.isExport) {
              this.$notify({
                title: '成功',
                message: '下载PDF中，请稍等一会',
                duration: 2000,
                type: 'success'
              })
              setTimeout(() => {
                // wsPdf.ws_pdf(document.querySelector("#main"), `${this.$route.query.reportId}个人报告 ${this.$route.query.studentName +
                //     new Date().toLocaleDateString()}`);
                getReportPdf(
                  '#main',
                  `${
                    this.$route.query.reportId +
                    '个体报告' +
                    this.$route.query.studentName
                  }`,
                  0.8
                )
              }, 1000)
            }
          }, 500)
        } else {
          // uni.showToast({
          // 	title: res.statusCode != 200 ? res.statusCode : res.data.msg,
          // 	icon: 'none'
          // });
        }
      })
    }
  }
}

/**

 setTimeout(() => {
                try {
                  var html = document.querySelector("#main");
                  let contentWidth = html.clientWidth; // 获得该容器的宽
                  let contentHeight = html.clientHeight; // 获得该容器的高
                  let canvas = document.createElement("canvas");
                  let scale = 1; // 解决清晰度问题，先放大 2倍

                  canvas.width = contentWidth * scale; // 将画布宽&&高放大两倍
                  canvas.height = contentHeight * scale;
                  canvas.getContext("2d").scale(scale, scale);

                  let opts = {
                    // scale: scale,
                    canvas: canvas,
                    // width: contentWidth,
                    // height: contentHeight,
                    useCORS: true,
                  };
                  window.Html2canvas ||
                  Html2Canvas(html, opts)
                      .then((canvas) => {
                        var contentWidth = canvas.width;
                        var contentHeight = canvas.height;

                        //一页pdf显示html页面生成的canvas高度;
                        var pageHeight = (contentWidth / 592.28) * 841.89;
                        //未生成pdf的html页面高度
                        var leftHeight = contentHeight;
                        //页面偏移
                        var position = 0;
                        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
                        var imgWidth = 595.28;
                        var imgHeight = (592.28 / contentWidth) * contentHeight;

                        var pageData = canvas.toDataURL("image/jpeg", 1.0);

                        var pdf = new jsPDF("", "pt", "a4");

                        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
                        //当内容未超过pdf一页显示的范围，无需分页
                        if (leftHeight < pageHeight) {
                          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
                        } else {
                          while (leftHeight > 0) {
                            pdf.addImage(
                                pageData,
                                "JPEG",
                                0,
                                position,
                                imgWidth,
                                imgHeight
                            );
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            //避免添加空白页
                            if (leftHeight > 0) {
                              pdf.addPage();
                            }
                          }
                        }
                        pdf.save(
                            `${this.$route.query.id}个人报告 ${
                                this.$route.query.studentId +
                                this.$route.query.studentName +
                                new Date().toLocaleDateString()
                            }.pdf`
                        );
                        //
                      })
                      .catch((err) => {
                      });
                } catch (err) {
                }
              }, 1000);

 */
</script>
<style lang="scss">
.reportContainer {
  width: 100%;
  overflow: hidden;
  padding-bottom: 304px;
  .coverContainer {
    img {
      width: 100%;
      height: auto;
    }
    margin: 0 auto;
    position: relative;
    .coverInfo {
      position: absolute;
      z-index: 1;
      top: 38%;
      left: 50%;
      font-size: 42px;
      color: #fff;
      font-weight: 700;
    }
  }
  .bigTitle {
    width: 620px;
    height: 56px;
    margin: 64px auto 101px;
  }
  .introT {
    background: url("../../assets/images/caseReport/intro_bigTitle.png")
      no-repeat center;
    background-size: 100% 100%;
  }
  .resultT {
    background: url("../../assets/images/caseReport/paperResultTitle.png")
      no-repeat center;
    margin-top: 88px;
    background-size: 100% 100%;
  }
  .ExplanT {
    background: url("../../assets/images/caseReport/scaleExplain.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 147px;
  }
  .noticeT {
    background: url("../../assets/images/caseReport/scaleNotice.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 88px;
  }
  .intro {
    width: 100%;
    padding: 0 143px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 56px;
    .introItem {
      margin-bottom: 58px;
    }
  }
  .detailContainner {
    width: 100%;
    padding: 0 143px;
    .detailItem {
      .itemTitle {
        width: 310px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .itemValue {
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
        margin-bottom: 47px;
      }
    }
  }
  .literatureContainer {
    width: 100%;
    min-height: 900px;
    padding: 0 143px;
    background: url("../../assets/images/caseReport/referenceBg.png") no-repeat
      right;
    background-size: 613px 900px;
    margin-top: 60px;
    .literatureItem {
      display: flex;
      margin-bottom: 37px;
      .literatureTitle {
        width: 34px;
        padding-top: 10px;
        margin-right: 26px;
        .icon {
          width: 34px;
          height: 34px;
          background: url("../../assets/images/caseReport/list_left.png")
            no-repeat center;
          background-size: 100% 100%;
        }
      }
      .literatureValue {
        width: 819px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
      }
    }
  }
  .resultChart {
    width: 700px;
    height: 600px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    #myCharts {
      width: 100%;
      height: 100%;
    }
  }
  .dimentionContainer {
    .dimention {
      margin-top: 63px;
      .dimentionLi {
        display: flex;
        flex-direction: column;
        padding: 0 143px;
        .dimentionTitle {
          display: flex;
          align-items: center;
          .icon {
            width: 34px;
            height: 34px;
            background: url("../../assets/images/caseReport/list_left.png")
              no-repeat center;
            background-size: 100% 100%;
            margin-right: 26px;
          }
          span {
            font-size: 28px;
            color: #333333;
            line-height: 56px;
          }
        }
        .content {
          font-size: 28px;
          color: #333333;
          line-height: 56px;
          .indicatorBar {
            margin-bottom: 65px;
            .bar {
              display: flex;
              align-items: center;
              div {
                position: relative;
                .arrow {
                  position: absolute;
                  bottom: -32px;
                  width: 32px;
                  height: 32px;
                  background: url("../../assets/images/caseReport/arrow.png")
                    no-repeat center;
                  background-size: 100% 100%;
                }
              }
            }
            .cognition {
              width: 840px;
            }
            .thinkingAndLanguage {
              width: 840px;
            }
            .personality {
              width: 1000px;
            }
            .mood {
              width: 520px;
            }
            .will {
              width: 840px;
            }
            .progressDiv {
              margin-right: 1px;
            }
            .earlyCss {
              border-radius: 50px 0px 0px 50px;
              background-image: linear-gradient(to right, #ff504b, #fd7d35);
            }
            .subhealthyCss {
              background-image: linear-gradient(to right, #fd8134, #fbb31c);
            }
            .commonlyCss {
              background-image: linear-gradient(to right, #fbb81b, #d1d21f);
            }
            .preferablyCss {
              background-image: linear-gradient(to right, #c9d321, #76da3f);
            }
            .highCss {
              border-radius: 0px 50px 50px 0px;
              background-image: linear-gradient(to right, #70db42, #20e15e);
            }
            .progressDivCss {
              margin-right: 1px;
              text-align: center;
            }
            .progressImg {
              width: 100%;
              height: 40px;
            }
            .progressText {
              color: #ffffff;
              font-size: 0.9em;
            }
          }
          span {
            font-size: 32px;
            font-weight: bold;
            color: #fab839;
            line-height: 56px;
            margin-right: 40px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 300px) and (max-width: 800px) {
    .intro {
      line-height: 50px;
      font-size: 20px;
      padding: 0 30px;
    }
    .detailContainner {
      width: 100%;
      padding: 0 50px;
      .detailItem {
        .itemTitle {
          width: 310px;
          height: 50px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .itemValue {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 56px;
          margin-bottom: 47px;
        }
      }
    }
    .literatureContainer {
      width: 100%;
      padding: 0 50px;
      .literatureItem {
        .literatureTitle {
          .icon {
            width: 26px;
            height: 26px;
          }
        }
        .literatureValue {
          font-size: 20px;
          line-height: 50px;
        }
      }
    }
  }
}
</style>
